
  import { ChevronDownIcon } from 'vue-feather-icons'

  export default {
    name: "Select",
    props: {
    },
    components: {
      ChevronDownIcon
    }
  }
